import GenericModel from '../generic-model';
import Product from '../product/product';
import ProjectContact from '../company/projectContact';
import { ProjectExtraCompanyContact } from './project-extra-company-contact';
import { SubProject } from './sub-project';
import Company from '../company/company';

export class Project extends GenericModel {
  oldPlatformId?: number;
  createdAt?: Date;
  subProjects: SubProject[];
  projectContacts?: ProjectContact[];
  collaborative?: boolean;
  otherCompanies?: string;
  projectExtraCompanyContacts?: ProjectExtraCompanyContact[];
  products?: Product[];

  withSoldRented = false;
  withAdjustment = false;
  withRepo = false;

  baseProjectNotExecuted?: boolean;

  allSubProjectsExecuted?: boolean;
  someSubProjectsInProgress?: boolean;
  typeMostRecentlyExecuted?: string;

  // Only for display in project tables
  involvedCompanies?: Company[];

  // Only for display in client corner popup
  popupDisplay?: string;

  constructor(id?: number) {
    super();
    if (id != null) {
      this.id = id;
    }
    this.products = [];
    this.subProjects = [];
    this.projectContacts = [new ProjectContact()];
    this.projectExtraCompanyContacts = [];
  }
}
